import type { STORYBLOK_ROUTES } from '#shared/constants/storyblok';

export interface UseStoryblokTranslatedRouteProps {
    slug: (typeof STORYBLOK_ROUTES)[keyof typeof STORYBLOK_ROUTES];
}

export type UseStoryblokTranslatedRouteReturn = Readonly<Ref<string>>;

export const useStoryblokTranslatedRoute = async ({ slug }: UseStoryblokTranslatedRouteProps): Promise<UseStoryblokTranslatedRouteReturn> => {
    // COMPOSABLES
    const { isDefaultLocale, locale } = useTypedI18n();

    // DATA
    const { story } = await useAsyncStoryblok(resolveStoryblokSlug(slug), {
        api: {
            ...(!isDefaultLocale.value ? { language: locale.value } : {}),
            version: 'published',
        },
        bridge: {},
    });

    const to = computed(() => {
        const s =
            story.value?.translated_slugs.find((s: StoryblokTranslatedSlug) => s.lang === locale.value)?.path ??
            story.value.default_full_slug ??
            slug;

        return `/${locale.value}/${s}`;
    });

    return readonly(to);
};
